(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class MarqueeComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const container = this.querySelector('.marquee-component');
      if (!container || !this.querySelector('.marquee-component_col')) return;
      const setOnPause = () => container.style.setProperty('--marquee-play-state', 'paused');
      const setOnResume = () => container.style.setProperty('--marquee-play-state', 'running');
      const initialize = () => {
        const { rotation, speed, direction, pauseOnHover } = this.dataset;
        const isRotated = !!rotation;
        const totalSize = isRotated ? container.scrollHeight : container.scrollWidth;
        const originalSize = totalSize / 3;
        if (originalSize <= 0) return;
        const speedVal = parseFloat(speed) || 10;
        const duration = originalSize / (speedVal * 2);
        const animationName = isRotated
          ? (direction === 'forward' ? 'marquee-vertical-forward' : 'marquee-vertical-reverse')
          : (direction === 'forward' ? 'marquee-horizontal-forward' : 'marquee-horizontal-reverse');
        container.style[isRotated ? 'height' : 'width'] = `${totalSize}px`;
        container.style.setProperty('--marquee-distance', `${originalSize}px`);
        container.style.setProperty('--marquee-duration', `${duration}s`);
        container.style.setProperty('--marquee-animation-name', animationName);
        container.style.setProperty('--marquee-play-state', 'running');
        container.classList.remove('marquee-component--h-scroll', 'marquee-component--v-scroll');
        this.querySelectorAll('[class*="cloned"] a, [class*="cloned"] button').forEach(el => {
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
        });
        if (pauseOnHover === 'true') {
          this.addEventListener('mouseenter', setOnPause);
          this.addEventListener('mouseleave', setOnResume);
        }
      };
      const observer = new ResizeObserver(() => initialize());
      observer.observe(this);
      setTimeout(initialize, 600);
    }
  }
  if (!customElements.get('marquee-component')) customElements.define('marquee-component', MarqueeComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-list"] && !Shopify.designMode) return;
  try {
    
  class MarqueeComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const container = this.querySelector('.marquee-component');
      if (!container || !this.querySelector('.marquee-component_col')) return;
      const setOnPause = () => container.style.setProperty('--marquee-play-state', 'paused');
      const setOnResume = () => container.style.setProperty('--marquee-play-state', 'running');
      const initialize = () => {
        const { rotation, speed, direction, pauseOnHover } = this.dataset;
        const isRotated = !!rotation;
        const totalSize = isRotated ? container.scrollHeight : container.scrollWidth;
        const originalSize = totalSize / 3;
        if (originalSize <= 0) return;
        const speedVal = parseFloat(speed) || 10;
        const duration = originalSize / (speedVal * 2);
        const animationName = isRotated
          ? (direction === 'forward' ? 'marquee-vertical-forward' : 'marquee-vertical-reverse')
          : (direction === 'forward' ? 'marquee-horizontal-forward' : 'marquee-horizontal-reverse');
        container.style[isRotated ? 'height' : 'width'] = `${totalSize}px`;
        container.style.setProperty('--marquee-distance', `${originalSize}px`);
        container.style.setProperty('--marquee-duration', `${duration}s`);
        container.style.setProperty('--marquee-animation-name', animationName);
        container.style.setProperty('--marquee-play-state', 'running');
        container.classList.remove('marquee-component--h-scroll', 'marquee-component--v-scroll');
        this.querySelectorAll('[class*="cloned"] a, [class*="cloned"] button').forEach(el => {
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
        });
        if (pauseOnHover === 'true') {
          this.addEventListener('mouseenter', setOnPause);
          this.addEventListener('mouseleave', setOnResume);
        }
      };
      const observer = new ResizeObserver(() => initialize());
      observer.observe(this);
      setTimeout(initialize, 600);
    }
  }
  if (!customElements.get('marquee-component')) customElements.define('marquee-component', MarqueeComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-banner"] && !Shopify.designMode) return;
  try {
    
  class MarqueeComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const container = this.querySelector('.marquee-component');
      if (!container || !this.querySelector('.marquee-component_col')) return;
      const setOnPause = () => container.style.setProperty('--marquee-play-state', 'paused');
      const setOnResume = () => container.style.setProperty('--marquee-play-state', 'running');
      const initialize = () => {
        const { rotation, speed, direction, pauseOnHover } = this.dataset;
        const isRotated = !!rotation;
        const totalSize = isRotated ? container.scrollHeight : container.scrollWidth;
        const originalSize = totalSize / 3;
        if (originalSize <= 0) return;
        const speedVal = parseFloat(speed) || 10;
        const duration = originalSize / (speedVal * 2);
        const animationName = isRotated
          ? (direction === 'forward' ? 'marquee-vertical-forward' : 'marquee-vertical-reverse')
          : (direction === 'forward' ? 'marquee-horizontal-forward' : 'marquee-horizontal-reverse');
        container.style[isRotated ? 'height' : 'width'] = `${totalSize}px`;
        container.style.setProperty('--marquee-distance', `${originalSize}px`);
        container.style.setProperty('--marquee-duration', `${duration}s`);
        container.style.setProperty('--marquee-animation-name', animationName);
        container.style.setProperty('--marquee-play-state', 'running');
        container.classList.remove('marquee-component--h-scroll', 'marquee-component--v-scroll');
        this.querySelectorAll('[class*="cloned"] a, [class*="cloned"] button').forEach(el => {
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
        });
        if (pauseOnHover === 'true') {
          this.addEventListener('mouseenter', setOnPause);
          this.addEventListener('mouseleave', setOnResume);
        }
      };
      const observer = new ResizeObserver(() => initialize());
      observer.observe(this);
      setTimeout(initialize, 600);
    }
  }
  if (!customElements.get('marquee-component')) customElements.define('marquee-component', MarqueeComponent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tlbs-conversion-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tlbs-product').forEach(function(section){
    var main=section.querySelector('.tlbs-main-image');
    var thumbs=section.querySelectorAll('.tlbs-thumb');
    function showMedia(image,mediaId,alt){
      if(main&&image){main.src=image;main.srcset='';if(alt){main.alt=alt;}}
      thumbs.forEach(function(item){item.classList.toggle('is-active',mediaId&&item.dataset.mediaId===mediaId);});
    }
    thumbs.forEach(function(button){button.addEventListener('click',function(){showMedia(button.dataset.image,button.dataset.mediaId,button.dataset.alt);});});
    var select=section.querySelector('[data-variant-select]');
    if(select){select.addEventListener('change',function(){
      var option=select.options[select.selectedIndex];
      section.querySelector('[data-price]').textContent=option.dataset.price;
      var compare=section.querySelector('[data-compare]');
      var priceCents=parseInt(option.dataset.priceCents||'0',10);
      var compareCents=parseInt(option.dataset.compareCents||'0',10);
      var savings=section.querySelector('[data-savings]');
      if(compareCents>priceCents){compare.textContent=option.dataset.compare;compare.hidden=false;if(savings){savings.textContent='Save $'+((compareCents-priceCents)/100).toFixed(2);savings.hidden=false;}}else{compare.hidden=true;if(savings){savings.hidden=true;}}
      var button=section.querySelector('[data-atc]');
      var available=option.dataset.available==='true';
      button.disabled=!available;
      showMedia(option.dataset.image,option.dataset.mediaId,option.dataset.alt);
      if(window.history&&window.history.replaceState){var url=new URL(window.location.href);url.searchParams.set('variant',option.value);window.history.replaceState({},'',url.toString());}
    });}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["utility-bar"]) return;
  try {
    
  class MarqueeComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const container = this.querySelector('.marquee-component');
      if (!container || !this.querySelector('.marquee-component_col')) return;
      const setOnPause = () => container.style.setProperty('--marquee-play-state', 'paused');
      const setOnResume = () => container.style.setProperty('--marquee-play-state', 'running');
      const initialize = () => {
        const { rotation, speed, direction, pauseOnHover } = this.dataset;
        const isRotated = !!rotation;
        const totalSize = isRotated ? container.scrollHeight : container.scrollWidth;
        const originalSize = totalSize / 3;
        if (originalSize <= 0) return;
        const speedVal = parseFloat(speed) || 10;
        const duration = originalSize / (speedVal * 2);
        const animationName = isRotated
          ? (direction === 'forward' ? 'marquee-vertical-forward' : 'marquee-vertical-reverse')
          : (direction === 'forward' ? 'marquee-horizontal-forward' : 'marquee-horizontal-reverse');
        container.style[isRotated ? 'height' : 'width'] = `${totalSize}px`;
        container.style.setProperty('--marquee-distance', `${originalSize}px`);
        container.style.setProperty('--marquee-duration', `${duration}s`);
        container.style.setProperty('--marquee-animation-name', animationName);
        container.style.setProperty('--marquee-play-state', 'running');
        container.classList.remove('marquee-component--h-scroll', 'marquee-component--v-scroll');
        this.querySelectorAll('[class*="cloned"] a, [class*="cloned"] button').forEach(el => {
          el.tabIndex = -1;
          el.setAttribute('aria-hidden', 'true');
        });
        if (pauseOnHover === 'true') {
          this.addEventListener('mouseenter', setOnPause);
          this.addEventListener('mouseleave', setOnResume);
        }
      };
      const observer = new ResizeObserver(() => initialize());
      observer.observe(this);
      setTimeout(initialize, 600);
    }
  }
  if (!customElements.get('marquee-component')) customElements.define('marquee-component', MarqueeComponent);

  } catch(e) { console.error(e); }
})();
})();
